
import React, { useState, useEffect, useContext } from "react";

import { useNavigate, useLocation, useParams } from "react-router-dom";
import { contentContext } from "../../context/contentContext";
import { keyActivate } from "../../utils/a11y";


const Sidebar = () => {
    let { id } = useParams();
    const location = useLocation();

    const [manage, setManage] = useState(false);
    const [report, setReport] = useState(false);
    const [settings, setSettings] = useState(false);
    const [auction, setAuction] = useState(false);
    const isActive = (path) => location.pathname === path ? 'active' : '';
    // const [activeMenuObj, setActiveMenuObj] = useState({});
    const navigate = useNavigate();


    const { isLoading, setIsLoading, setActiveTab, flagg, setData, setClientInfo, clientInfo, businessData, setBusinessData, setBidsAdvSearch, setSaveLeadId, setlookUpType, setBidsSearch, setLookupSearch, setClientNameSearch, setFlagg, setActivePageName, setUserSearch, setCompanyAdvSearch, setCompanySearch, setClientMangeSearch, setDealSearch, setClientAdvSearch, setDealsAdvSearch, userData, setContent, setSearchPayload, setCategorySearch, setContentSearch, leadSearch, setFilterLeads, setLeadSearch, setActiveSearch, setUserData, activeMenuObj, setActiveMenuObj, activeMenuId, GetTimeActivity, toggleMenu, setToggleMenu, setActiveMenuId, setSortingPayload, setItemSearch,guardedNavigate } = useContext(contentContext)



    //      const handleMenu = (e, item) => {
    //          if (!isLoading && activeMenuId !== item.menuid) {
    //              setActiveTab("details")
    //              // console.log('handleMenu-------------->',item.menuid)

    //              setActiveMenuId(item.menuid)
    //              let id = item.menu.split(" ").join("").toLowerCase()
    //              GetTimeActivity()
    //              setFlagg("")
    //              setLeadSearch("")
    //              setActiveSearch("")
    //              setFilterLeads("")
    //              setContentSearch("")
    //              setCategorySearch("")
    //              setSearchPayload({})
    //              setClientAdvSearch({})
    //              setBidsSearch("")
    //              setItemSearch("");
    //              setDealSearch("")
    //              setSortingPayload("")
    //              setlookUpType("")
    //              setClientNameSearch("")
    //              setSaveLeadId("")
    //              setDealsAdvSearch({})
    //              setData([])
    //              setLookupSearch("")
    //              setClientMangeSearch("")
    //              setBidsAdvSearch({})
    //              setCompanyAdvSearch({})
    //              setCompanySearch("")
    //              setUserSearch("")
    //              setActivePageName("")
    //              setContent([])
    //              if(userData?.usertype==="BRAND MANAGER"){
    //                 setBusinessData(clientInfo)
    //              }
    //             //  if (id==="servicesconfig") {
    //             //      navigate("/settings/serviceconfig");
    //             //  } else if (id==="appconfig") {
    //             //      navigate("/settings/" + id);
    //             //  }
    //             //  else {
    //             //      navigate("/" + id);
    //             //  }
    //   navigate("/" + id);
    //          }
    //      }
    useEffect(() => {
        // clear states only after route is updated
        setLeadSearch("");
        setActiveSearch("");
        setFilterLeads("");
        setContentSearch("");
        setCategorySearch("");
        setSearchPayload({});
        setClientAdvSearch({});
        setBidsSearch("");
        setItemSearch("");
        setDealSearch("");
        setSortingPayload("");
        setlookUpType("");
        setClientNameSearch("");
        setSaveLeadId("");
        setDealsAdvSearch({});
        setData([]);
        setLookupSearch("");
        setClientMangeSearch("");
        setBidsAdvSearch({});
        setCompanyAdvSearch({});
        setCompanySearch("");
        setUserSearch("");
        setActivePageName("");
        setContent([]);
    }, [location.pathname]);
    const menuRoute = (item) => "/" + item.menu?.split(" ").join("").toLowerCase();
    const handleMenu = (e, item) => {
        guardedNavigate(()=>{

       
        if (!isLoading && activeMenuId !== item.menuid) {
            setActiveTab("details");
            setActiveMenuId(item.menuid);
            setFlagg(""); // if you want to clear this immediately
            if (userData?.usertype === "BRAND MANAGER") {
                setBusinessData(clientInfo);
            }
            navigate(menuRoute(item));
        }
         })
    };
    function sortPermissions(permissions) {
        return permissions.sort((a, b) => a.menuid - b.menuid);
    }

    const handleActiveMenuObj = (e, name) => {
        GetTimeActivity()
        setActiveTab("details")
        setFlagg("")
        setLeadSearch("")
        setActiveSearch("")
        setFilterLeads("")
        setCategorySearch("")
        setDealsAdvSearch({})
        setContent([])
        setDealSearch("")
        setClientMangeSearch("")

        setBidsAdvSearch({})
        setClientNameSearch("")
        setLookupSearch("")
        setClientAdvSearch({})
        setCompanySearch("")
        setSearchPayload({})
        setlookUpType("")
        setCompanyAdvSearch({})
        setActivePageName("")
        setUserSearch("")
        // console.log('handleActiveMenuObj------------>',name)
        setActiveMenuObj({ ...activeMenuObj, [name]: !activeMenuObj[name] })

    }

    const handleMenuClick = (path) => {
        navigate(path);

    };
    // Fallback entry for legacy clients only. userData.permissions is a one-time
    // snapshot copied onto each client at signup from the
    // clienttypedefaultpermissions template, so clients created before Payouts
    // was added to that template have no Payouts item. Clients whose snapshot
    // does include it render it from permissions like any other menu - injecting
    // this one as well would show Payouts twice. Rendered directly above the
    // permission-driven "Scan" item, or at the end of the menu when this client
    // has no Scan item.
    const payoutsMenuItem = (
        <li
            key="sidebar-payouts"
            id="sidebar-payouts"
            className={`${location.pathname === '/payouts' ? 'active' : ''} ${isLoading ? 'pe-none' : ''}`}
            onClick={() => guardedNavigate(() => { GetTimeActivity(); navigate("/payouts"); })}
            onKeyDown={keyActivate(() => guardedNavigate(() => { GetTimeActivity(); navigate("/payouts"); }))}
        >
            <a className="waves-effect">
                <i className="material-symbols-outlined">payments</i>
                <span>Payouts</span>
            </a>
        </li>
    );
    const isScanMenu = (item) => item.display && item.menu?.trim().toLowerCase() === 'scan';
    const isPayoutsMenu = (item) => item.display && item.menu?.trim().toLowerCase() === 'payouts';
    // activeMenuId is only set on click (and to the first menu at sign-in), so a
    // refresh or a redirect onto a menu's route left nothing highlighted. When
    // the route belongs to a menu item that item is the active one; otherwise
    // fall back to activeMenuId, which pages off the menu (profile, upgrade,
    // notifications) set for themselves.
    const routeMatchedMenuId = userData?.permissions?.find(
        // menuRoute lowercases, and a route such as /proUsers does not, so compare
        // the way react-router matches: case-insensitively.
        (item) => item.display && item.submenus === undefined && menuRoute(item) === location.pathname.toLowerCase()
    )?.menuid;
    const isActiveMenuItem = (item) =>
        routeMatchedMenuId === undefined ? item.menuid === activeMenuId : item.menuid === routeMatchedMenuId;
    const hasScanMenu = userData?.permissions?.some(isScanMenu);
    const hasPayoutsMenu = userData?.permissions?.some(isPayoutsMenu);
    const showStaticPayouts = userData?.permissions?.length > 0 && !hasPayoutsMenu;

    // Payouts belongs directly above Scan, but the menu is ordered by menuid and
    // Payouts was added to the permissions template last, so it sorts to the end.
    const orderPayoutsBeforeScan = (permissions) => {
        const payoutsIndex = permissions.findIndex(isPayoutsMenu);
        const scanIndex = permissions.findIndex(isScanMenu);
        if (payoutsIndex === -1 || scanIndex === -1 || payoutsIndex < scanIndex) return permissions;
        const rest = permissions.filter((item) => !isPayoutsMenu(item));
        return [...rest.slice(0, scanIndex), permissions[payoutsIndex], ...rest.slice(scanIndex)];
    };

    // console.log("usertypeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",userData)
    return (


        <>

            <div className={`vertical-menu client-vertical-menu ${toggleMenu ? 'menu-show' : 'menu-hide'}`}             >

                <div data-simplebar className="h-100">

                    <div id="sidebar-menu">
                        <ul className="metismenu list-unstyled" id="side-menu">
                            {userData?.permissions?.length > 0
                                ? orderPayoutsBeforeScan(sortPermissions(userData.permissions)).map((eachItem) => {
                                    const isDisplay = eachItem.display;
                                    const menuId = `sidebar-${eachItem.menu?.toLowerCase().replace(/\s+/g, '-')}`;

                                    // skip non-displayed items early to avoid returning fragments without keys
                                    if (!isDisplay) return null;

                                    const menuItem = (
                                        <li
                                            key={eachItem.menuid}
                                            id={menuId}
                                            className={`${isActiveMenuItem(eachItem) ? 'active' : ''} ${isLoading ? 'pe-none' : ''}`}
                                            onClick={(e) =>
                                                eachItem.submenus === undefined
                                                    ? handleMenu(e, eachItem)
                                                    : handleActiveMenuObj(e, eachItem.menu)
                                            }
                                            onKeyDown={keyActivate((e) =>
                                                eachItem.submenus === undefined
                                                    ? handleMenu(e, eachItem)
                                                    : handleActiveMenuObj(e, eachItem.menu)
                                            )}
                                        >
                                            <a className={`${eachItem.submenus ? 'has-arrow' : ''} waves-effect`}>
                                                {/* The permissions snapshot ships Payouts with the same
                                                    icon as Transactions, so the two menus look identical.
                                                    Overridden here to match the static entry above until
                                                    the permissions data itself is corrected. */}
                                                <i className="material-symbols-outlined">{isPayoutsMenu(eachItem) ? 'payments' : eachItem.icon}</i>
                                                <span>{eachItem.menu}</span>
                                            </a>

                                            {eachItem.submenus?.length > 0 && (
                                                <ul
                                                    className={
                                                        activeMenuObj[eachItem.menu]
                                                            ? 'sub-menu mm-show active'
                                                            : 'sub-menu mm-collapse'
                                                    }
                                                    aria-expanded="false"
                                                >
                                                    {eachItem.submenus.map((eachSubmenu) => {
                                                        const submenuId = `sidebar-${eachItem.menu
                                                            ?.toLowerCase()
                                                            .replace(/\s+/g, '-')}-${eachSubmenu.menu
                                                                ?.toLowerCase()
                                                                .replace(/\s+/g, '-')}`;
                                                        return (
                                                            <li
                                                                key={eachSubmenu.menuid}
                                                                id={submenuId}
                                                                className={`${eachSubmenu.menuid === activeMenuId ? 'active' : ''} ${isLoading ? 'pe-none' : ''}`}
                                                                onClick={(e) => handleMenu(e, eachSubmenu)}
                                                                onKeyDown={keyActivate((e) => handleMenu(e, eachSubmenu))}
                                                            >
                                                                <a>{eachSubmenu.menu}</a>
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            )}
                                        </li>
                                    );

                                    return isScanMenu(eachItem) && showStaticPayouts ? [payoutsMenuItem, menuItem] : menuItem;
                                })
                                : null}

                            {/* Fallback for clients whose permissions have no Scan item -
                                otherwise Payouts is rendered inline just above Scan. */}
                            {showStaticPayouts && !hasScanMenu && payoutsMenuItem}
                        </ul>

                    </div>

                    <p className="activity_time">Action: {localStorage.getItem("timeActivity")}</p>

                </div>
            </div>

        </>
    );
};

export default Sidebar;
